import React from "react";
import { Headphones } from "lucide-react";
import ComingSoonFormat from "@/components/site/ComingSoonFormat";

export default function Listen() {
  return (
    <ComingSoonFormat
      testId="listen-page"
      label="Listen"
      Icon={Headphones}
      headline="Audio is on the way."
      description="Full audio interviews and conversations with operators, in a form you can take with you. Same editorial standard as the written work, less compressed."
      bullets={[
        "Long-form audio interviews with contributors.",
        "Short audio versions of published articles.",
        "Discussions between operators on shared operating problems.",
        "Available in a standard podcast feed and on the site.",
      ]}
    />
  );
}
